import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import useViewport from "components/general/useViewPort";
import { isLiveStatus } from "helpers/status";


export function ScoreContainer(props) {
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  const { resultObj, resultStatus, type } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const winner = resultObj?.wlt === 'W' && <div className='score-winner'><FontAwesomeIcon className='' icon={faCheck} /></div>
  const result = resultObj?.result;
  const isLive = isLiveStatus(resultStatus)
  const isSchedule = type === 'SCHEDULE'
  const isBracket = type === 'BRACKET' || type === 'RIBBON'
  const hidePartial = (isSchedule && isMobile && !isLive);

  const outOthers = (
    <div className='score-result-container d-flex flex-row justify-content-end align-self-center w-100'>
      <div className="align-self-center row w-100 m-0">
        <div className='col-2 p-0 small'>
          {winner}
        </div>
        <div className={`col-3 p-0 small text-end ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
          {result}&nbsp;
        </div>
        {resultObj?.extra?.resultG1 && !hidePartial && <div className="text-end p-0 col small align-self-center">{resultObj?.extra?.resultG1}&nbsp;</div>}
        {resultObj?.extra?.resultG2 && !hidePartial && <div className="text-end p-0 col small align-self-center">{resultObj?.extra?.resultG2}&nbsp;</div>}
        {resultObj?.extra?.resultG3 && !hidePartial && <div className="text-end p-0 col small align-self-center">{resultObj?.extra?.resultG3}</div>}
        {resultObj?.hasIRM === true
          ? <div className="col p-0 fw-bold small">
            <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true}  small={true}/>
          </div>
          : ''}
      </div>
    </div>   
  );

  const outBrackets = (
    <div className='score-result-container d-flex flex-row justify-content-end align-self-center w-35'>
      <div className="align-self-center row w-100 m-0 ms-1">
        <div className='col-2 p-0 small'>
          {winner}
        </div>
        <div className={`col-3 p-0 small text-end ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
          {result}&nbsp;
        </div>
        {resultObj?.extra?.resultG1 && !hidePartial && <div className="text-end p-0 col small align-self-center">{resultObj?.extra?.resultG1}&nbsp;</div>}
        {resultObj?.extra?.resultG2 && !hidePartial && <div className="text-end p-0 col small align-self-center">{resultObj?.extra?.resultG2}&nbsp;</div>}
        {resultObj?.extra?.resultG3 && !hidePartial && <div className="text-end p-0 col small align-self-center">{resultObj?.extra?.resultG3}</div>}
        {resultObj?.hasIRM === true
          ? <div className="col p-0 fw-bold small">
            <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true}  small={true}/>
          </div>
          : ''}
      </div>
    </div>   
  );
  
  return isBracket ? outBrackets : outOthers;
}